// extracted by mini-css-extract-plugin
export default {"wrap":"Progress_wrap__S-8mZ","progress":"Progress_progress__U4pom","content":"Progress_content__2wp5f"};